export const billStatusTag = 'billStatus:';
